import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-spinner-filled',
  imports: [SpinnerComponent],
  templateUrl: './spinner-filled.component.html',
  styleUrl: './spinner-filled.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerFilledComponent {
  public readonly size = input<string>('2rem');
}
